import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Label } from '../Forms';
import { useThemeColors } from '../../utility/hooks/useThemeColors';
import { PoppinsMedium } from '../Fonts';

const LabelValueWrapper = ({
	title,
	value,
	isRequired,
	fontFamily,
	titleColor,
	style
}) => {
	const colors = useThemeColors();
	return (
		<Flex direction="column" flexWrap="wrap" align="start" style={style}>
			<Label
				width={'100%'}
				isRequired={isRequired}
				fontFamily={fontFamily}
				titleColor={titleColor}
			>
				{title}
			</Label>
			<PoppinsMedium
				className="label_value_wrapper"
				width={'100%'}
				color={colors.gray[700]}
			>
				{value}
			</PoppinsMedium>
		</Flex>
	);
};

export default LabelValueWrapper;
